import { CreatorShopFundingsPage } from './CreatorShopFundingsPage.ts';

export const creatorShopFundingsRouter = {
  '/challenges': CreatorShopFundingsPage,
};
